export enum IdentityGrandTypes {
    password = 'password',
    cognito = 'cognito',
    refresh_token = 'refresh_token',
    external = 'external'
}